<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <label for="" class="form-label">Idioma</label>
                            <select v-model="idioma" class="form-control form-control-sm">
                                <option value="">Todos</option>
                                <option v-for="item in idiomasDisponibles" :key="item" :value="item">{{ item }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <label for="" class="form-label">Tipo</label>
                            <select v-model="tipo" class="form-control form-control-sm">
                                <option value="">Todos</option>
                                <option v-for="item in tiposDisponibles" :key="item" :value="item">{{ item }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                
            </div> 
        </div>
        <div class="tablasDivididas">
            <div>
                <ul class="list-unstyled d-flex justify-content-between">
                    <li><strong>Registros:</strong> {{ resumenIzquierda.registros }}</li>
                    <li class="ml-2"><strong>Inglés:</strong> {{ resumenIzquierda.ingles }}</li>
                    <li class="ml-2"><strong>Español:</strong> {{ resumenIzquierda.espanol }}</li>
                    <li class="ml-2"><strong>Royal:</strong> {{ resumenIzquierda.royal }}</li>
                    <li class="ml-2"><strong>Regular:</strong> {{ resumenIzquierda.regular }}</li>
                </ul>
                
            </div>
            <div></div>
            <div>
                <ul class="list-unstyled d-flex justify-content-between">
                    <li><strong>Registros:</strong> {{ resumenDerecha.registros }}</li>
                    <li class="ml-2"><strong>Inglés:</strong> {{ resumenDerecha.ingles }}</li>
                    <li class="ml-2"><strong>Español:</strong> {{ resumenDerecha.espanol }}</li>
                    <li class="ml-2"><strong>Royal:</strong> {{ resumenDerecha.royal }}</li>
                    <li class="ml-2"><strong>Regular:</strong> {{ resumenDerecha.regular }}</li>
                </ul>
            </div>
            <div class="tablaContenedor">
                <div class="table-responsive">
                    <table class="table table-sm table-bordered" ref="tablaIzquierda">
                        <thead class="table-secondary">
                            <tr class="text-center align-middle text-nowrap">
                                <th>Cód.</th>
                                <th>Nombre</th>
                                <th>Hotel</th>
                                <th>H. R.</th>
                                <th>Agencia</th>
                                <th>Tipo</th>
                                <th>Idioma</th>
                                <th>P. A.</th>
                                <th>P. N.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in tablaIzquierdaFiltrada" @click.exact="onClickItem('izquierda', item, index)" @click.shift="onClickItem('izquierda', item, index, true)" :class="{'table-primary': item.selected == true}" :key="item.idBibliaRegistro" class="text-center align-middle text-nowrap">
                                <td>{{ item.codigo }}</td>
                                <td>{{ item.nombre }}</td>
                                <td>{{ item.hotel }}</td>
                                <td>{{ item.horaRecojo }}</td>
                                <td>{{ item.agencia }}</td>
                                <td>{{ item.tipo }}</td>
                                <td>{{ item.idioma }}</td>
                                <td>{{ item.nroAdultos }}</td>
                                <td>{{ item.nroNinos }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="tablaControles">
                <button @click="onClickArrow('left')" data-control="1" class="btn btn-icon btn-xs btn-light-primary">
                    <span class="fa fa-fw fa-angle-left font-size-lg"></span>
                </button>
                <button @click="onClickArrow('right')" data-control="1" class="btn btn-icon btn-xs btn-light-primary">
                    <span class="fa fa-fw fa-angle-right font-size-lg"></span>
                </button>
                <button @click="onClickArrow('dleft')" data-control="1" class="btn btn-icon btn-xs btn-light-primary">
                    <span class="fa fa-fw fa-angle-double-left font-size-lg"></span>
                </button>
                <button @click="onClickArrow('dright')" data-control="1" class="btn btn-icon btn-xs btn-light-primary">
                    <span class="fa fa-fw fa-angle-double-right font-size-lg"></span>
                </button>
            </div>
            <div class="tablaContenedor">
                <div class="table-responsive">
                    <table class="table table-sm table-bordered" ref="tablaDerecha">
                        <thead class="table-primary">
                            <tr class="text-center align-middle text-nowrap">
                                <th>Cód.</th>
                                <th>Nombre</th>
                                <th>Hotel</th>
                                <th>H. R.</th>
                                <th>Agencia</th>
                                <th>Tipo</th>
                                <th>Idioma</th>
                                <th>P. A.</th>
                                <th>P. N.</th>
                            </tr>
                        </thead>
                        <draggable v-model="tablaDerecha" group="people" @start="drag=true" @end="drag=false" tag="tbody">
                            <tr v-for="(item, index) in tablaDerecha" @click.exact="onClickItem('derecha', item, index)" @click.shift="onClickItem('derecha', item, index, true)" :class="{'table-primary': item.selected == true}" :key="item.idBibliaRegistro" class="text-center align-middle text-nowrap">
                                <td>{{ item.codigo }}</td>
                                <td>{{ item.nombre }}</td>
                                <td>{{ item.hotel }}</td>
                                <td>{{ item.horaRecojo }}</td>
                                <td>{{ item.agencia }}</td>
                                <td>{{ item.tipo }}</td>
                                <td>{{ item.idioma }}</td>
                                <td>{{ item.nroAdultos }}</td>
                                <td>{{ item.nroNinos }}</td>
                            </tr>
                        </draggable>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable
    },
    props: {
        izquierda: {
            type: Array,
            default() {
                return []
            }
        },
        derecha: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            tablaIzquierda: this.izquierda,
            tablaDerecha: this.derecha,
            idioma: '',
            tipo: '',
            lastIndex: 0,
        }
    },
    mounted() {
        let vm = this;
        window.addEventListener('click', vm.onWindowClick, false);
            
            
    },
    beforeDestroy() {
        let vm = this;
        window.removeEventListener('click', vm.onWindowClick, false);
    },
    watch: {
        tablaIzquierda: {
            handler() {
                this.updateValue();
            },
            deep: true
        },
        tablaDerecha: {
            handler() {
                this.updateValue();
            },
            deep: true
        }
    },
    computed: {
        idiomasDisponibles() {
            let vm = this;
            let idiomas = [];
            let todosLosRegistros = [...vm.tablaIzquierda, ...vm.tablaDerecha];
            todosLosRegistros.forEach(item => idiomas.push(item.idioma));
            idiomas = idiomas.filter(item => item);
            idiomas = [...new Set(idiomas)];
            return idiomas;
        },
        tiposDisponibles() {
            let vm = this;
            let tipos = [];
            let todosLosRegistros = [...vm.tablaIzquierda, ...vm.tablaDerecha];
            todosLosRegistros.forEach(item => tipos.push(item.tipo));
            tipos = tipos.filter(item => item);
            tipos = [...new Set(tipos)];
            return tipos;
        },
        tablaIzquierdaFiltrada() {
            let vm = this;
            return vm.tablaIzquierda.filter(item => {
                let coincide = vm.idioma == '' ? true : item.idioma == vm.idioma;
                coincide = coincide && (vm.tipo == '' ? true : item.tipo == vm.tipo);
                return coincide;
            })
        },
        resumenIzquierda() {
            let vm = this;
            let tempTabla = [...vm.tablaIzquierdaFiltrada];
            let registros = tempTabla.length;
            let sumaEspanol = 0,
                sumaIngles = 0,
                sumaRoyal = 0,
                sumaRegular = 0;
            
            tempTabla.forEach(item => {
                if (item.idioma == 'Español') sumaEspanol += (Number(item.nroAdultos) + Number(item.nroNinos));
                if (item.idioma == 'Inglés') sumaIngles += (Number(item.nroAdultos) + Number(item.nroNinos));
                if (item.tipo == 'Royal') sumaRoyal += (Number(item.nroAdultos) + Number(item.nroNinos));
                if (item.tipo == 'Regular') sumaRegular += (Number(item.nroAdultos) + Number(item.nroNinos));
            });

            return { registros, espanol: sumaEspanol, ingles: sumaIngles, royal: sumaRoyal, regular: sumaRegular };
        },
        resumenDerecha() {
            let vm = this;
            let tempTabla = [...vm.tablaDerecha];
            let registros = tempTabla.length;
            let sumaEspanol = 0,
                sumaIngles = 0,
                sumaRoyal = 0,
                sumaRegular = 0;
            
            tempTabla.forEach(item => {
                if (item.idioma == 'Español') sumaEspanol += (Number(item.nroAdultos) + Number(item.nroNinos));
                if (item.idioma == 'Inglés') sumaIngles += (Number(item.nroAdultos) + Number(item.nroNinos));
                if (item.tipo == 'Royal') sumaRoyal += (Number(item.nroAdultos) + Number(item.nroNinos));
                if (item.tipo == 'Regular') sumaRegular += (Number(item.nroAdultos) + Number(item.nroNinos));
            });

            return { registros, espanol: sumaEspanol, ingles: sumaIngles, royal: sumaRoyal, regular: sumaRegular };
        }
    },
    methods: {
        onClickItem(pTabla, pItem, pIndex, pShift = false) {
            let vm = this;
            pItem.selected = !pItem.selected;
            let indices = [Number(String(vm.lastIndex).slice()), Number(pIndex)];
            indices.sort();

            if(pShift) {
                if(pTabla == 'izquierda') {
                    vm.tablaIzquierda.forEach((item, index) => {
                        if(index >= indices[0] && index <= indices[1]) item.selected = true;
                    })
                }else {
                    vm.tablaDerecha.forEach((item, index) => {
                        if(index >= indices[0] && index <= indices[1]) item.selected = true;
                    })
                }
            }
            vm.lastIndex = pIndex;
        },
        onClickArrow(pArrow) {
            let vm = this;
            let tempTablaIzquierda = vm.tablaIzquierda.slice();
            let tempTablaDerecha = vm.tablaDerecha.slice();

            if(pArrow == 'left') {
                let noSelecteds = tempTablaDerecha.filter(item => item.selected == false);
                let selecteds = tempTablaDerecha.filter(item => item.selected);
                if(selecteds.length) {
                    // selecteds.forEach(item => item.selected = false);
                    tempTablaIzquierda = [...tempTablaIzquierda, ...selecteds];
                    vm.tablaIzquierda = tempTablaIzquierda;
                    vm.tablaDerecha = noSelecteds;
                }
            }

            if(pArrow == 'right') {
                let noSelecteds = tempTablaIzquierda.filter(item => item.selected == false);
                let selecteds = tempTablaIzquierda.filter(item => item.selected);
                if(selecteds.length) {
                    // selecteds.forEach(item => item.selected = false);
                    tempTablaDerecha = [...tempTablaDerecha, ...selecteds];
                    vm.tablaDerecha = tempTablaDerecha;
                    vm.tablaIzquierda = noSelecteds;
                }
            }

            if(pArrow == 'dleft') {
                let selecteds = tempTablaDerecha;
                selecteds.forEach(item => item.selected = true);
                tempTablaIzquierda = [...tempTablaIzquierda, ...selecteds];
                vm.tablaIzquierda = tempTablaIzquierda;
                vm.tablaDerecha = [];
            }

            if(pArrow == 'dright') {
                let selecteds = vm.tablaIzquierdaFiltrada.slice();
                let codigosSeleccionados = selecteds.map(item => item.idBibliaRegistro);
                let noSeleccionados = tempTablaIzquierda.filter(item => !codigosSeleccionados.includes(item.idBibliaRegistro));
                selecteds.forEach(item => item.selected = true);
                tempTablaDerecha = [...tempTablaDerecha, ...selecteds];
                vm.tablaDerecha = tempTablaDerecha;
                vm.tablaIzquierda = noSeleccionados;
            }
        },
        updateValue() {
            let vm = this;
            vm.$emit('update', {
                izquierda: vm.tablaIzquierda.slice(),
                derecha: vm.tablaDerecha.slice()
            })
        },
        onWindowClick(e) {
            let vm = this;
            if(e.target.dataset.control || e.target.parentElement.dataset.control) return;

            if (!vm.$refs.tablaIzquierda.contains(e.target)){
                let selecteds = vm.tablaIzquierda.filter(item => item.selected == true);
                if(selecteds.length) {
                    vm.tablaIzquierda.forEach(item => {
                        item.selected = false;
                    });
                }
            }

            if (!vm.$refs.tablaDerecha.contains(e.target)){
                let selecteds = vm.tablaDerecha.filter(item => item.selected == true);
                if(selecteds.length) {
                    vm.tablaDerecha.forEach(item => {
                        item.selected = false;
                    });
                }
            }
        }
    }
}
</script>
